<template>
    <div>
        <van-loading v-if="ld"></van-loading>
        <div class="order_status" v-if="!ld">
            <div class="icon">
                <van-icon color="var(--theme)" name="success" v-if="status == 1"/>
                <van-icon color="var(--theme)" name="cross" v-else/>
            </div>
            <p class="w_1" v-if="msg == ''">{{status == 1? '支付成功': '支付失败'}}</p>
            <p class="w_1" v-else>{{ msg }}</p>
            <p class="w_2" v-if="status == 1">预计1-3个工作日发货</p>
            <van-button plain round color="var(--theme)" v-if="status == 1&&msg==''" @click="gotoDetail">查看订单</van-button>
            <van-button plain round color="var(--theme)" v-else @click="kefu">联系客服</van-button>
            <van-button round color="var(--theme)" @click="gotoHome">返回交易市场</van-button>
        </div>
        
    </div>
</template>

<script>
    export default {
        data() {
            return {
                status: null,
                order_num: '',
                goods_type: null,
                ld: true,
                msg: ''
            }
        },
        computed: {
            userData() {
                return this.$store.getters.state.userData || {};
            },
            out_trade_no() {
                return this.$route.query.out_trade_no || ''
            },
            order_number() {
                return this.$route.query.order_num || ''
            },
            type() {
                return this.$route.query.type || ''
            }
        },
        created() {

        },
        mounted() {
            if(this.order_number != '') {
                this.order_num = this.order_number
            }
            if(this.out_trade_no != '') {
                this.getOrderStatus()
            }else {
                this.ld = false
                this.status = 1
            }
        },
        methods: {
            getOrderStatus() {
                this.$Ajax('pay/checkout-order',{
                    out_trade_no: this.out_trade_no
                },'get').then(rs => {
                    if(rs.code == 200) {
                        this.status = rs.data.status
                        this.order_num = rs.data.order_num
                        this.goods_type = rs.data.goods_type
                    }else  {
                        if(rs.msg == '订单不存在') {
                            this.msg = '订单不存在'
                        }
                    }
                    setTimeout(() => {
                        this.ld = false
                    },2000)
                }).finally(() => {
                    setTimeout(() => {
                        this.ld = false
                    },2000)
                })
            },
            //联系客服
            kefu() {
                window.location.href = 'https://livechathuyu.gmmsj.com/index/index/kefu?u=6265f471b483e&platform=8&game_id=8889&game_name=G买卖&uid=8_'+ this.userData.user_id +'&phone=' + this.userData.username
            },
            gotoHome() {
                this.$router.push({
                    name: 'home'
                })
            },
            gotoDetail() {
                if(this.goods_type == 1 || this.type == 'props') {
                    this.$router.push({
                      name: "goods.detail",
                      query: {
                        order_num: this.order_num,
                        type: "buy"
                      },
                    });
                }else {
                    this.$router.push({
                        name: 'user.order',
                        query: {
                            order_num: this.order_num,
                            type: 'buy'
                        }
                    })
                }
            }
        },
        watch: {

        },
    }
</script>

<style lang="less" scoped>
.order_status {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6rem 1.5rem;
    .icon {
        width: 4.3rem;
        height: 4.3rem;
        border: 2px solid var(--theme);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1.6rem;
        .van-icon {
            font-size: 3rem;
            font-weight: 700;
        }
    }
    .w_1 {
        font-size: 1.8rem;
        font-weight: 700;
        margin-bottom: 1.2rem;
        text-align: center;
    }
    .w_2 {
        font-size: 1.4rem;
        color: #606060;
        text-align: center;
        margin-bottom: 2rem;
    }
    .van-button {
        width: 100%;
        margin-bottom: 1.8rem;
        font-size: 1.6rem;
    }
}
/deep/.van-loading {
    margin: 10rem auto 0;
    display: flex;
    justify-content: center;
}
</style>